import { render } from "./verify-website.vue?vue&type=template&id=1a3842e6&scoped=true"
import script from "./verify-website.vue?vue&type=script&lang=js"
export * from "./verify-website.vue?vue&type=script&lang=js"

import "./verify-website.vue?vue&type=style&index=0&id=1a3842e6&lang=scss&scoped=true"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3842e6"]])

export default __exports__